import * as types from './types'
import { processRecords } from '@/store/utils'

const actions = {
  INIT ({ commit, firebase }) {},
  async [types.GET_LIST] ({ commit, firebase, rootGetters }) {
    const currentCompany = rootGetters['global/currentCompanyId']

    firebase
      .firestore()
      .collection(`companies/${currentCompany}/serviceFiles`)
      .onSnapshot(querySnapshot => {
        let records = processRecords(querySnapshot)

        commit('setList', records)
      })
  }
}

export default actions
